import { State } from '../../../store/state';
 
export const valorizationSelector = (state: State) => state.valorization.valorization;
export const loadingSelector = (state: State) => state.valorization.loading;
export const errorCodeSelector = (state: State) => state.valorization.errorCode; 